/**
 * Choosing a password, as every app has it (L-13, Jason, 2026-10-07: "just use the same best practices for password
 * management that every app on earth uses"): Account's Set a password and Change password, and choosing one on the
 * way in. The rule is shown before anything is typed, and the button is never held back: pressed, it sends, or says in
 * words why not. The API holds the same rule (`apps/api/src/passwords.ts`) and says whether the current one is right.
 */
export const PASSWORD_MIN = 10;
export const PASSWORD_RULE = 'At least ten characters.';

/** Why the form will not send yet, in words, or null to send it. `current` is null where none is asked for. */
export function passwordRefusal(f: { current: string | null; password: string; again: string }): string | null {
  if (f.current !== null && f.current === '') return 'Fill in your current password.';
  if (f.password === '') return 'Fill in a new password.';
  if (f.password.trim().length < PASSWORD_MIN) return 'Too short: a password needs at least ten characters.';
  if (f.again === '') return 'Fill in the new password again, to confirm it.';
  if (f.again !== f.password) return 'The two new passwords are not the same.';
  if (f.current !== null && f.current === f.password) return 'Choose a new password, not the one you have.';
  return null;
}
